import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ExpandableListItem } from '../models/expandable-list-item.model';
import {ExpandableListOrderedComponent} from './expandable-list-ordered.component';

@Component({
  selector: 'expandable-list-combo',
  templateUrl: 'expandable-list-combo.component.html',
  styleUrls: ['expandable-list-combo.component.scss']
})

export class ExpandableListComboComponent extends ExpandableListOrderedComponent implements OnInit, OnChanges {

  
  @Output() emitWarning = new EventEmitter();
  
  @Input() OrderedList: boolean;
  @Input() groupArray: string[]=[];
  @Input() groupByPlaceHolder: string;
  @Input() type: string = 'expandable-list';
  id: number = 1

  selectedText: ExpandableListItem;
  selectedInfo: string;
  selectedGroup : string;

  ngOnChanges() {
    super.ngOnChanges();
  }
  ngOnInit() {
    if(this.groupArray==undefined) this.groupArray=[];
  }

  onComboAdd() {
    if (this.validateDuplicates) {
      if (this.validateRequired) {
        if (!this.skipRowUpdate) {
          this.selectedText = { id: 0, cells: [{ value: this.selectedInfo }], displayValue: this.selectedInfo };
          this.selectedText.displayValue = this.selectedInfo;
          if(this.groupArray.length>0){
          this.selectedText.groupby = this.selectedGroup;
          }
          this.rows.push(this.selectedText);
          this.refreshOrder(this.rows);  
          this.rowsChange.emit(this.rows);
          this.selectedInfo = '';
        }
      }
    }
    else {
      this.emitWarning.emit(this.selectedGroup);
    }
  }
  get validateRequired():boolean{
    if(this.groupArray.length>0){
      return this.selectedInfo && this.selectedGroup ? true: false;
    }
    else{
      return this.selectedInfo ? true: false;
    }
  }
  get validateDuplicates():boolean{
    if(this.groupArray.length>0){
      return !this.rows.some(item => item.displayValue == this.selectedInfo && item.groupby==this.selectedGroup);
    }
    else{
      return !this.rows.some(item => item.displayValue == this.selectedInfo)
    }
  }
  getId(name:string): string{
    return name.replace(/ /g, '');
  }
  onComboRemove(row: ExpandableListItem, skipCallBack: boolean) {
    let name = row.displayValue ? row.displayValue : row ;
    if (this.removeItemCallBack.observers.length > 0 && !skipCallBack) {
      let paramArray :any[] = [this, name];
      if(this.groupArray.length>0){
        paramArray = [this,row];
      }
      this.removeItemCallBack.emit(paramArray);
    }
    else {
      if (!this.skipRowUpdate) {
          this.limitedRowsReached.emit(false);
          if(this.groupArray.length>0){
            this.rows = this.rows.filter(f=> {return (f.displayValue!==row.displayValue || f.groupby!==row.groupby);});
          }
          else{
            this.rows = this.rows.filter(item => item.displayValue != name);
          }
          this.rows.forEach((element,index) => {
                 element.order = index+1;
         });
        this.rowsChange.emit(this.rows);
      }
    }
  }
}
